import { Accordion } from "react-bootstrap"
import SubHeader from "../../Components/SubHeader";
import MetaTags from "../../Components/MetaTags";

const HealthCoinsFAQ = () => {

  return (
    <>
      <MetaTags data={{ title: 'SBL Health Coins FAQs and Help' }} />
      <SubHeader heading="SBL Health Coins FAQs and Help" />
      <div className="container my-5">
        <Accordion>
          {healthCoinsFaqData?.map((item, i) => (
            <Accordion.Item eventKey={i} key={i}>
              <Accordion.Header><span className="fw-bolder text-primary">{item?.question}</span></Accordion.Header>
              <Accordion.Body>
                <p className="text-muted" dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  )
}

export default HealthCoinsFAQ;

const healthCoinsFaqData = [
  {
    question: "What are SBL Health Coins?",
    answer:
      "SBL Health Coins are reward points that customers earn on successful purchases. These coins can be redeemed as discounts on future orders, helping you save more on your health and wellness products."
  },
  {
    question: "How can I earn SBL Health Coins?",
    answer:
      "You earn SBL Health Coins when your order is successfully delivered."
  },
  {
    question: "How many SBL Health Coins do I earn on each order?",
    answer:
      "You earn SBL Health Coins equivalent to <strong>5% of your order value</strong> on every successfully delivered order."
  },
  {
    question: "When will SBL Health Coins be credited to my account?",
    answer:
      "Health Coins are credited after the order is successfully delivered and reflected in your account within <strong>24–48 hours</strong>."
  },
  {
    question: "How can I check my SBL Health Coins balance?",
    answer:
      `
      You can check your Health Coins balance by:
      <ul>
        <li>Logging into your account on our website/app</li>
        <li>Visiting the <strong>Profile / SBL Health Coins</strong> section</li>
      </ul>
      `
  },
  {
    question: "How can I redeem SBL Health Coins?",
    answer:
      `
      You can redeem SBL Health Coins at checkout:
      <ul>
        <li>Select <strong>Use SBL Health Coins</strong> on the payment page</li>
        <li>The eligible Health Coins will be adjusted with your order value</li>
      </ul>
      `
  },
  {
    question: "What is the value of SBL Health Coins?",
    answer:
      `
      <strong>1 SBL Health Coin = ₹1</strong><br/>
      (Subject to change as per company policy or promotional offers)
      `
  },
  {
    question: "Is there a minimum order value to use SBL Health Coins?",
    answer:
      "No, there is no minimum order value to use the SBL Health Coins."
  },
  {
    question: "Do SBL Health Coins expire?",
    answer:
      "Yes, SBL Health Coins typically expire after <strong>12 months</strong> from the date of credit."
  },
  {
    question: "What happens if I cancel or return my order?",
    answer:
      `
      If an order is cancelled or returned, the SBL Health Coins earned on that order will be <strong>reversed</strong>.
      `
  },
  {
    question: "Can SBL Health Coins be transferred to another account?",
    answer:
      "No, SBL Health Coins are non-transferable and can only be used by the registered customer."
  },
  {
    question: "Can SBL Health Coins be redeemed for cash?",
    answer:
      "No, SBL Health Coins cannot be redeemed for cash or transferred to any bank account. They can be used only for redemption with onwards purchases."
  },
  {
    question: "Are SBL Health Coins applicable on COD orders?",
    answer:
      "Yes, SBL Health Coins are applicable on both <strong>Prepaid</strong> and <strong>COD</strong> orders, provided the order is successfully delivered."
  },
  {
    question: "Whom should I contact for SBL Health Coins-related issues?",
    answer:
      `
      For any SBL Health Coins-related queries:
      <ul>
        <li>📞 Customer Support: +91-11-43731000, 43731025, 35301970</li>
         <li>
    <img
      src="/asset/images/whatsup.png"
      alt="WhatsApp"
      title="WhatsApp"
      width="20"
      height="20"
    />
    WhatsApp:
    <a 
      href="https://wa.me/918851654420"
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary fw-bold"
    >
      +91-8851654420
    </a>
  </li>
  <li>📧 Email: <a href="mailto:onlinecare@sblglobal.in">
    onlinecare@sblglobal.in
  </a></li>
      </ul >
  `
  }
];
